/* eslint-disable max-len */

export default {
	'Registration': {
		'en': 'Registration',
		'ru': 'Зарегистрироваться'
	},
	'Login': {
		'en': 'Login',
		'ru': 'Войти'
	},
	'Offers': {
		'en': 'Offers',
		'ru': 'Офферы'
	},
	'Store': {
		'en': 'Store',
		'ru': 'Магазин'
	},
	'Webmaster': {
		'en': 'Webmaster',
		'ru': 'Вебмастеру'
	},
	'News': {
		'en': 'News',
		'ru': 'Новости'
	},
	'Events': {
		'en': 'Events',
		'ru': 'Мероприятия'
	},
	'Menu': {
		'en': 'Menu',
		'ru': 'Меню'
	},
	'en': {
		'en': 'Eng',
		'ru': 'Eng'
	},
	'ru': {
		'en': 'Рус',
		'ru': 'Рус'
	},
	'points': {
		'en': 'QUID',
		'ru': 'QUID'
	},
	'point': {
		'en': 'QUID',
		'ru': 'QUID'
	},
	'Gift store': {
		'en': 'Gifts shop',
		'ru': 'Магазин подарков'
	},
	'Register at RocketProfit and': {
		'en': 'Register at RocketProfit and',
		'ru': 'Регистрируйся в RocketProfit и'
	},
	' start your traf on converting offers': {
		'en': ' start your traf on converting offers',
		'ru': ' пускай траф на конвертящие офферы'
	},
	'Получай монеты RocketGOLD': {
		'en': 'Get QUID coins',
		'ru': 'Получай монеты QUID'
	},
	'за каждый апрувнутый лид': {
		'en': 'for each approved lead',
		'ru': 'за каждый апрувнутый лид'
	},
	'Выбирай подарки': {
		'en': 'Выбирай подарки',
		'ru': 'Выбирай подарки'
	},
	'и расплачивайся бонусом': {
		'en': ' и расплачивайся бонусом',
		'ru': ' и расплачивайся бонусом'
	},
	'Exchange accumulated QUID coins': {
		'en': ' Exchange accumulated QUID coins',
		'ru': ' Меняй накопленные монеты QUID'
	},
	' for valuable gifts': {
		'en': ' for valuable gifts',
		'ru': ' на ценные подарки'
	},
	'Privacy policy': {
		'en': 'Privacy policy',
		'ru': 'Политика конфиденциальности'
	},
	'Gifts': {
		'en': 'Gifts',
		'ru': 'Подарки'
	},
	'Yes': {
		'en': 'Yes',
		'ru': 'Да'
	},
	'No': {
		'en': 'No',
		'ru': 'Нет'
	},
	'Do you confirm your order?': {
		'en': 'Do you confirm your order?',
		'ru': 'Вы подтверждаете ваш заказ?'
	},
	'Order failed': {
		'en': 'Order failed',
		'ru': 'Ошибка при заказе'
	},

	'Your points': {
		'en': 'Your QUID',
		'ru': 'Вы можете использовать количество QUID'
	},
	'Thanks for order': {
		'en': 'Thank you for the order!',
		'ru': 'Спасибо за заказ!'
	},
	'Ticket for address': {
		'en': 'A ticket with a form will appear in the "Support" section soon.',
		'ru': 'В течение ближайшего времени в разделе «Поддержка» появится тикет с формой для уточнения адреса доставки,'
	},
	'Fill form please': {
		'en': 'Fill this form to specify the delivery address, please.',
		'ru': 'заполните её, пожалуйста.'
	},
	'QUID exchange processed': {
		'en': 'Your request to exchange QUID to $ has been processed!',
		'ru': 'Ваш запрос на обмен QUID в $ обработан!'
	},
	'Transaction completed': {
		'en': 'The transaction is complete',
		'ru': 'Транзакция завершена.'
	},
	'Have a question?': {
		'en': 'Have a question? Contact us:',
		'ru': 'Возникли вопросы? Пишите:'
	},
	'Understand': {
		'en': 'Ok',
		'ru': 'Понятно'
	},
	'Rules of affiliate program': {
		'en': 'Affiliate Program Policy',
		'ru': 'Условия партнерской программы'
	},
	'All categories': {
		'en': 'All categories',
		'ru': 'Все категории'
	},
	'Categories': {
		'en': 'Categories',
		'ru': 'Категории'
	},
	'Show more': {
		'en': 'Show more',
		'ru': 'Показать еще'
	},
	'Popular first': {
		'en': 'Popular first',
		'ru': 'Сначала популярные'
	},
	'Lowest price': {
		'en': 'Lowest price',
		'ru': 'По возрастанию стоимости'
	},
	'Highest price': {
		'en': 'Highest price',
		'ru': 'По убыванию стоимости'
	},
	'Available to me': {
		'en': 'Available to me',
		'ru': 'Доступные мне'
	},
	'Search gift': {
		'en': 'Search by gifts',
		'ru': 'Поиск по подаркам'
	},
	'Order': {
		'en': 'Buy',
		'ru': 'Заказать'
	},
	'Want save-up for': {
		'en': 'Start saving for',
		'ru': 'Хочу накопить'
	},
	'Stop save-up for': {
		'en': 'Stop saving for',
		'ru': 'Перестать копить'
	},
	'Вернуться к списку товаров': {
		'en': 'Back to the good list',
		'ru': 'Вернуться к списку товаров'
	},
	'all': {
		'en': 'All categories',
		'ru': 'Все категории'
	},
	'Without sort': {
		'en': 'Sort by',
		'ru': 'Сортировать'
	},
	'By category': {
		'en': 'By category',
		'ru': 'По категориям'
	},
	'New first': {
		'en': 'Newest',
		'ru': 'Сначала новые'
	},
	'By name': {
		'en': 'Name',
		'ru': 'По названию'
	},
	'All': {
		'en': 'All',
		'ru': 'Все'
	},
	'market-rules:rule-1': {
		'en': 'Promotion includes all offers and all GEO of RocketProfit affiliate network.',
		'ru': 'В акции участвуют все офферы и все ГЕО партнерской сети RocketProfit.'
	},
	'market-rules:rule-2': {
		'en': 'QUID - is not a joke, but a real space currency, which stands for Quasi-Universal Intergalactic Denomination, abbreviated - quid (QUID). Moreover, it is an internal virtual currency of store.rocketprofit.com',
		'ru': 'QUID - это вам не шутки, а самая настоящая космическая валюта, которая расшифровывается как квазиуниверсальная интергалактическая деноминация, сокращенно - куид (QUID). А также это внутренняя виртуальная валюта store.rocketprofit.com'
	},
	'market-rules:rule-3': {
		'en': '1 QUID is charged according to the internal algorithm and can vary depending on GEO, offer, shares.',
		'ru': '1 QUID начисляется в соответствии с внутренним алгоритмом и может меняться в зависимости от ГЕО, оффера, акций.'
	},
	'market-rules:rule-4': {
		'en': 'The accumulated amount of QUID is displayed in your personal account on rocketprofit.com',
		'ru': 'Накопленное количество QUID отображается в личном кабинете rocketprofit.com'
	},
	'market-rules:rule-5': {
		'en': 'The relevant amount of QUID is debited from the promo participant for each ordered product. In case of absence of selected product or inability to arrange delivery to the customer, the organizer reserves the right to replace the product with one having similar price or characteristics of the goods already presented.',
		'ru': 'За каждый заказанный товар с участника акции списывается соответствующее ему количество QUID. В случае отсутствия выбранного товара или невозможности организовать доставку до заказчика, организатор оставляет за собой право заменить товар аналогичным по цене или характеристикам из уже представленных товаров.'
	},
	'market-rules:rule-6': {
		'en': 'All QUID earned and not spent by the webmaster will be automatically deducted on a daily basis after more than 180 days from the date they appear on the balance.',
		'ru': 'Все QUID, заработанные и не потраченные веб-мастером, будут автоматически списываться на ежедневной основе по истечении более 180 дней с момента их появления на балансе.'
	},
	'market-rules:rule-7': {
		'en': 'All promo participants are obliged to comply with the rules of the affiliate network. In case of any violations, the account in RocketProfit will be blocked, and the QUID balance will be canceled.',
		'ru': 'Все участники акции обязуются соблюдать правила работы с партнёрской сетью. За нарушение любого из правил учётная запись в RocketProfit будет заблокирована, а баланс QUID аннулирован.'
	},
	'market-rules:rule-8': {
		'en': 'The promotion terms and conditions may be changed unilaterally by the organizer by posting information about the relevant changes (along with the new version of the promotion terms and conditions) on the website, and the organizer is entitled to terminate the promotion ahead of time. At the same time, users and participants of the promotion are not entitled to demand any compensation and indemnities.',
		'ru': 'Условия акции могут быть изменены организатором в одностороннем порядке путем размещения информации о соответствующих изменениях условий акции (вместе с новой редакцией условий акции) в сети интернет на сайте, в том числе организатор вправе досрочно прекратить проведение акции. При этом пользователи и участники акции не имеют права требовать каких-либо компенсаций и возмещения ущерба.'
	},
	'market-rules:rule-9': {
		'en': 'Accrual and use of QUID points are only possible during the store.rocketprofit.com operation.',
		'ru': 'Начисление и использование баллов QUID возможно только во время работы магазина store.rocketprofit.com'
	},
	'market-rules:rule-10': {
		'en': 'Free delivery of gifts is carried out in the CIS countries. The delivery of gifts from store.rocketprofit.com to other countries must be agreed with your personal manager.',
		'ru': 'Бесплатная доставка подарков осуществляется по всей территории СНГ. Доставку подарков из store.rocketprofit.com в другие страны необходимо согласовывать со своим личным менеджером.'
	},
	'market-rules:rule-11': {
		'en': 'RocketProfit reserves the right to change the value of the ordered but not shipped goods, subject to changes in the purchase price from the supplier. In case of a change in the value of the goods, a personal manager will contact the partner. The partner has the right to refuse the ordered goods for a new cost, deducted QUID will be returned back to the balance.',
		'ru': 'RocketProfit оставляет за собой право изменять стоимость заказанного, но не отгруженного товара при условии изменения закупочной стоимости у поставщика. В случае изменения стоимости товара с партнером свяжется личный менеджер. Партнер имеет право отказаться от заказанного товара за новую стоимость, списанные QUID будут возвращены обратно на баланс.'
	},
	'Not enough points, need to': {
		'en': 'Not enought QUID, it\'s necessary',
		'ru': 'Недостаточно QUID, нужно еще'
	},
	'more': {
		'en': 'more',
		'ru': ' '
	}
};



// WEBPACK FOOTER //
// ./frontend/cabinets/apps/rocket/modules/market/translation/index.js